// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import dataTableStyles from "@pace/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { savedOrdersStyles } from "@pace/App/Widgets/Common/SavedOrders";
import { css } from "styled-components";

savedOrdersStyles.container = {
    css: css`
        overflow: auto;
    `,
};
savedOrdersStyles.centeringWrapper = {
    ...dataTableStyles.centeringWrapper,
};
savedOrdersStyles.spinner = {
    css: css`
        margin: auto;
    `,
};

savedOrdersStyles.sectionWrapperStyles = {
    wrapper: {
        css: css`
            & > div {
                height: 100%;
            }
        `,
    },
};
savedOrdersStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};
savedOrdersStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};
savedOrdersStyles.subtotalHeader = {
    sortClickableProps: {
        css: css`
            justify-content: flex-end;
            width: 100%;
        `,
    },
};
savedOrdersStyles.subtotalCell = {
    alignX: "left",
};
savedOrdersStyles.sectionWrapperStyles = {
    wrapper: {
        css: css`
            & > div {
                height: 100%;
            }
            margin-bottom: 32px;
        `,
    },
    title: {
        wrapper: {
            css: css`
                margin-bottom: 16px;
            `,
        },
    },
};
